import { Outlet } from "react-router-dom";
import AppNavbar from "./AppNavbar";

export default function AppShell() {
  return (
    <div className="min-h-screen bg-black text-white">
      <AppNavbar />
      <main className="max-w-[1400px] mx-auto px-4 sm:px-8 py-8">
        <Outlet />
      </main>
      <footer className="border-t border-brand-blue/30 mt-16 py-8 px-4 text-center text-xs text-white/50 font-roboto">
        © {new Date().getFullYear()} MYDORITECH — Reconditionné premium français · hello@mydoritech.com
      </footer>
    </div>
  );
}
